import {
  Box,
  Button,
  Input,
  Stack,
  Text,
  useToast,
  HStack,
} from "@chakra-ui/react";
import { useState } from "react";
import axiosInstance from "../../config/axiosInstance";
import OrdersTable from "./ReceptionistOrders/OrdersTable";

const Track = () => {
  const [searchType, setSearchType] = useState("bill");
  const [query, setQuery] = useState("");
  const [result, setResult] = useState([]);
  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(false);

  const toast = useToast();

  const handleSearch = async () => {
    if (!query.trim()) return;
    if (!searchType) {
      toast({
        title: "Please select a search type",
        status: "warning",
        isClosable: true,
      });
      return;
    }
    
    setLoading(true);
    setSearched(false);

    try {
      const res = await axiosInstance.get(
        `/api/orders/receptionist?search=${query}&searchType=${searchType}`
      );
      setResult(res.data.orders || []);
    } catch (err) {
      const status = err?.response?.status;
      const message = err?.response?.data?.message || "Failed to fetch orders";
      if (status >= 500 || !status) {
        toast({
          title: message,
          status: "error",
          isClosable: true,
        });
      }
      setResult([]);
    } finally {
      setLoading(false);
      setSearched(true);
    }
  };

  const handleSearchTypeChange = (newSearchType) => {
    setSearchType(newSearchType);
    // Clear previous search results when changing search type
    setResult([]);
    setSearched(false);
  };



  return (
    <Box p={{ base: 4, md: 6 }} bg="gray.50" minH="100vh">
      <Box bg="white" p={6} rounded="md" boxShadow="sm" mb={6}>
        <Text fontWeight="bold" color="red.500" mb={2}>
          Track your order
        </Text>

        <HStack spacing={2} mb={2}>
          <Text
            onClick={() => handleSearchTypeChange("bill")}
            cursor="pointer"
            fontWeight={searchType === "bill" ? "bold" : "normal"}
            color={searchType === "bill" ? "red.500" : "gray.600"}
            _hover={{ color: "red.400" }}
            transition="color 0.2s"
          >
            Bill number
          </Text>
          <Text color="gray.500">/</Text>
          <Text
            onClick={() => handleSearchTypeChange("phone")}
            cursor="pointer"
            fontWeight={searchType === "phone" ? "bold" : "normal"}
            color={searchType === "phone" ? "red.500" : "gray.600"}
            _hover={{ color: "red.400" }}
            transition="color 0.2s"
          >
            Phone number
          </Text>
        </HStack>
        
        <Text 
          fontSize="sm" 
          color="gray.600" 
          mb={3}
          fontWeight="medium"
        >
          Currently searching by: <Text as="span" color="red.500" fontWeight="bold">
            {searchType === "bill" ? "Bill Number" : "Phone Number"}
          </Text>
        </Text>

        <Stack direction="row" spacing={3}>
          <Input
            placeholder={`Enter ${
              searchType === "bill" ? "Bill number" : "Phone number"
            }`}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSearch();
              }
            }}
          />
          <Button 
            colorScheme="red" 
            onClick={handleSearch} 
            isLoading={loading}
            leftIcon={<Text fontSize="xs">🔍</Text>}
          >
            Search by {searchType === "bill" ? "Bill" : "Phone"}
          </Button>
        </Stack>
      </Box>

      {result.length > 0 && (
        <Box bg="white" p={6} rounded="md" boxShadow="sm">
          <Text mb={4}>
            Showing results for <b>{query}</b> (searched by {searchType === "bill" ? "Bill Number" : "Phone Number"})
          </Text>
          <OrdersTable
            data={result}
            fetchOrders={handleSearch}
            orderLoading={loading}
          />
        </Box>
      )}

      {searched && result.length === 0 && (
        <Box
          bg="white"
          p={6}
          rounded="md"
          boxShadow="sm"
          textAlign="center"
          mt={4}
        >
          <Text color="red.500" fontWeight="bold" mb={2}>
            No order found with this{" "}
            {searchType === "bill" ? "bill number" : "phone number"}
          </Text>
          <Text fontSize="sm" color="gray.600">
            Searched for: <Text as="span" fontWeight="bold">{query}</Text> 
            (using {searchType === "bill" ? "Bill Number" : "Phone Number"} search)
          </Text>
        </Box>
      )}


    </Box>
  );
};

export default Track;